<template>
  <div class="nav">
      <div class="flex flex-row">
        <button v-if="!hideBackButton" @click="onClickBackButton">
          <img class="back_button" :src="icon_arrow_left" />
        </button>
        <div class="flex items-center">
          <div class="body_5 back_content">{{ props.title }}</div>
        </div>
      </div>
      <div class="flex items-center">
        <button
          :class="hideNoticeButton ? 'pr-4' : ''"
          @click="onClickCustomerSupportButton">
          <img src="@/assets/icons/icon_callcenter.svg" />
        </button>
        <button
          v-if="!hideNoticeButton"
          class="pr-4 pl-3"
          @click="onClickNoticeButton">
          <img src="@/assets/icons/icon_notice.svg" />
        </button>
      </div>
    </div>
</template>

<script setup>
import icon_arrow_left from "@/assets/icons/icon_arrow_left_black.svg";
import router from "@/router/index";
import { useLayoutStore } from "@/stores/layoutStore";
import { useAuthStore } from "@/stores/authStore";
import { useCustomerSupport } from "@/composables/useCustomerSupport";

const authStore = useAuthStore();
const layoutStore = useLayoutStore();
const { onClickCustomerSupportButton } = useCustomerSupport();

const props = defineProps({
  title: {
    type: String,
    required: false,
    default: ''
  },
  hideBackButton: {
    type: Boolean,
    required: false,
    default: false,
  },
  hideNoticeButton: {
    type: Boolean,
    required: false,
    default: false,
  }
})

// Action
const onClickBackButton = () => {
  router.back();
};

const onClickNoticeButton = () => {
  if (window.flutter_inappwebview) {
    if (authStore.isLogined()) {
      window.flutter_inappwebview.callHandler("routeAlarm", {});
    } else {
      layoutStore.showNeedLoginAlert();
    }
  } else {
    layoutStore.showUseMobileAlert();
  }
};
</script>

<style scoped>
.nav {
  height: 52px;
  width: 100%;
  display: flex;
  align-content: center;
  justify-content: space-between;
  overflow-y: hidden;
}

.back_button {
  height: 24px;
  width: 24px;
  margin: 8px 12px 8px 16px;
}
.back_content {
  margin: 8px 0;
  width: 240px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>